// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"pageTitle__titleContainer___KoPvS","dark":"pageTitle__dark___q8Dlv","light":"pageTitle__light___vXmbA"};